import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { QuillEditorModel } from '@app/components/controls/utilities/models/quill-editor-model';
import { SkillsSelectionModel } from '@app/components/controls/utilities/models/skills-selection-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { ApiService as ProfileApiService } from '@app/modules/people/utilities/services/api.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { UntypedFormGroup } from '@angular/forms';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { ApiService as ChannelsApiService } from '@app/modules/channels/utilitites/services/api.service';

@Component({
	selector: 'app-questions-forms',
	templateUrl: './questions-forms.component.html',
	styleUrls: ['./questions-forms.component.scss']
})
export class QuestionsFormsComponent implements OnInit {

	popupRef;
	formFields: Array<any> = [];
	loader = false;
	config = { fxFlex: 100 };
	submitDisable = true;
	formObject: any = {};
	currentUser;
	helpTriggered = false;
	action: 'addQuestion' | 'editQuestion';
	formObjectData = {
		form: null,
		fields: []
	};
	skillLevelData = [];
	skillFormFields = [];
	showDescription = true;
	title: TextBoxModel;
	description: QuillEditorModel;
	skills: SkillsSelectionModel | AutoCompleteModel;
	resourceDetail;
	actualSKills = [];
	clearTimeout;
	experts: AutoCompleteModel;
	showUser = true;
	usersData = [];
	visibilityField = [];
	formLoader = true;
	formTitle = '';

	constructor(
		private gfService: GlobalFunctionService,
		private apiService: ApiService,
		public locale: LocaleService,
		private baseService: BaseService,
		private profileApiService: ProfileApiService,
		private resourceApiService: ResourceApiService,
		private cdref: ChangeDetectorRef,
		private appInit: AppInitializerService,
		private globalApiService: GlobalApiService,
		private channelsApiService: ChannelsApiService,
		private renderer2: Renderer2,
		private elementRef: ElementRef
	) {
		this.currentUser = this.gfService.sessionUser;
		this.currentUser = this.gfService.sessionUser;
		if (this.currentUser.weightageData) {
			this.skillLevelData = this.currentUser.weightageData.map((data) => {
				return {
					key: data.termID,
					value: data.term,
					weightage: data.index,
					description: data.attributes.description
				};
			});
		}
	}

	ngOnInit(): void {
		this.baseService.formView = true;
		if (this.action === 'addQuestion' || this.action === 'editQuestion') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.formLoader = true;
			this.title = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('question'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('question')
			};
			this.description = {
				fieldCaption: this.locale.translate('page'),
				fieldColumn: 'description',
				validationRegex: '',
				validationMessage: '',
				fieldOrder: 1,
				fieldType: 'quillEditor',
				fieldHelpText: '',
				isRequired: false,
				isHidden: true,
				additionalMetaData: {
					// height: 400,
					showLabel: false,
					imageUploadData: {
						fileSize: '10MB',
						supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
						url: ''
					},
					config: {
						toolbar: [
							['link', 'image', 'video', 'formula', 'code-block']
						],
						// toolbar: '#toolbar-container',
						formula: true,
						imageResize: true
					}
				},
				isReadonly: true,
				value: null,
				fieldPlaceholder: ''
			};
			this.skills = {
				fieldCaption: this.locale.translate('skills'),
				fieldColumn: 'skills',
				validationMessage: null,
				fieldOrder: 1,
				fieldType: 'skillsSelectionField',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('skills'),
				isRequired: false,
				isHidden: false,
				options: null,
				additionalMetaData: {
					maxWeightage: this.skillLevelData,
					minWeightage: 0,
					defaultWeightage: 0,
					showHelp: true,
					showLabel: true,
					selectionType: 'standard'
				},
				isReadonly: false,
				value: null
			};
			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};


			const headers: any = {};

			this.profileApiService.userCompetency(this.currentUser.userID, headers).subscribe(
				(response) => {
					if (response && response.competencies && response.competencies.length) {
						this.skills.options = this.dataBuild(response.competencies);
					} else {
						this.skills = {
							fieldColumn: 'skills',
							additionalMetaData: {
								showLabel: true,
								autoFill: 'off'
							},
							fieldType: 'autoComplete',
							isHidden: false,
							isMultiple: true,
							isReadonly: false,
							isRequired: false,
							options: [],
							selectedValue: [],
							fieldCaption: this.locale.translate('search_skills'),
							fieldOrder: 3,
							preDefined: false,
							fieldPlaceholder: this.locale.translate('search_skills')
						};
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {

					if (this.action === 'editQuestion') {
						this.formTitle = this.locale.translate('edit_question');
						const headers: any = {
							lanCode: sessionStorage.getItem('locale') || 'en'
						};
						this.resourceApiService.detail(this.resourceDetail.resourceID, headers).subscribe(
							(response) => {
								if (response) {
									this.resourceDetail = response;
									this.title.value = this.resourceDetail.title;
									this.description.value = this.resourceDetail.description;
									if (this.resourceDetail.infoFields && this.resourceDetail.infoFields.experts && this.resourceDetail.infoFields.experts.length) {
										this.usersData = this.resourceDetail.infoFields.experts.map(user => {
											return {
												isAdd: true,
												isDelete: false,
												key: user.userID,
												value: `${user.firstName}${user.lastName
													? ' ' + user.lastName
													: ''}`
											};
										});
									}
									if (this.usersData && this.usersData.length) {
										this.tagExperts();
									}
									if (this.resourceDetail.skills && Array.isArray(this.resourceDetail.skills)) {
										const skillValue = [];
										for (const skillData of this.resourceDetail.skills) {
											const pushJson: any = {
												key: skillData.skill.key,
												value: skillData.skill.value,
												skillLevel: skillData.skillLevel
											};
											if (this.skills.fieldType === 'autoComplete') {
												pushJson.isAdd = true;
												pushJson.isDelete = false;
											}
											skillValue.push(pushJson);
										}
										this.skills.value = skillValue;
										if (this.skills.fieldType === 'autoComplete') {
											this.skills['selectedValue'] = skillValue;
										}
									}

								}
							},
							(error) => {
								this.gfService.errorHandler(error, {
									snackBar: {
										position: 'before'
									}
								});
							}
						)
							.add(() => {
								if (this.baseService.checkModuleAccess('M13')) {
									this.skillFormFields = [this.skills];
								}
								if (this.helpTriggered) {
									this.loader = false;
								} else {
									this.popupRef.componentInstance.popupLoader = false;
								}
								this.submitDisable = false;
								this.formLoader = false;
								if (this.description.value) {
									this.cdref.detectChanges();
									this.addDescription();
								}
							});
					} else if (this.action === 'addQuestion') {
						this.formTitle = this.locale.translate('ask_a_question');
						if (this.usersData && this.usersData.length) {
							this.tagExperts();
						}
						this.loadChannel(channel);
						if (this.baseService.checkModuleAccess('M13')) {
							this.skillFormFields = [this.skills];
						}
						this.visibilityField = [channel];
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
						this.formLoader = false;
						this.submitDisable = false;
					}
				});
		}
	}

	loadChannel(channelField) {
		channelField.options = [];
		const apiData = {};
		const headers: any = {};

		let selectedValue = [];
		if (channelField.selectedValue.length) {
			channelField.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push(items.key);
				}
			});
		}
		this.channelsApiService.getChannelList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.channelID)) {
								return items;
							}
						});
					}
					channelField.options = response.records.map((data) => {
						return {
							key: data.channelID,
							value: data.channelName
						};
					});
				}

			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		);
	}

	tagExperts(field?) {
		if (!this.experts) {
			this.experts = {
				fieldColumn: 'experts',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('search_user'),
				fieldOrder: 3,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_user')
			};
			if (this.usersData && this.usersData.length) {
				this.experts.value = [...this.usersData];
				this.experts.selectedValue = [...this.usersData];
			}
		}
		// if (field) {
		// 	let elem = this.elementRef.nativeElement.querySelector(field);
		// 	console.log(elem);
		// 	elem.getElementsByTagName('input')[0].focus();
		// }
	}

	addDescription(field?) {
		// if(field){
		// 	let elem = this.renderer2.selectRootElement('#myInput');
		// }
		this.description.isRequired = false;
		this.description.isReadonly = false;
		this.description.isHidden = false;
		this.formObjectData.form.controls.description.enable();
		this.showDescription = false;
	}

	dataBuild(records: any) {
		let skillData;
		let data = [];
		for (const competency of records) {
			competency.childData = {
				caption: null,
				data: []
			};
			for (const skill of competency.skills) {
				const pushJson = {
					key: skill.ID,
					value: skill.name,
					skillLevel: skill.skillLevel | 0,
					expectedSkillLevel: skill.expectedSkillLevel
				};
				this.actualSKills.push(pushJson);
				competency.childData.data.push(pushJson);
			}
			data.push({
				key: competency.ID,
				value: competency.name,
				childData: competency.childData,
				selected: false
			});
		}
		if (data.length > 0) {
			skillData = {
				caption: this.locale.translate('select_competency'),
				data
			};
		}
		return skillData;
	}

	navigateToBack() {
		this.showUser = false;
		this.title.isReadonly = false;
		this.description.isReadonly = false;
		this.skills.isReadonly = false;
		if (this.experts) {
			this.experts.isReadonly = true;
			this.formObjectData.form.controls.experts.disable({ emitEvent: false });
		}
		this.formObjectData.form.controls.title.enable({ emitEvent: false });
		this.formObjectData.form.controls.description.enable({ emitEvent: false });
		this.formObjectData.form.controls.skills.enable({ emitEvent: false });
	}

	done() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('add-alert');
			this.submitDisable = true;
			let valid = false;
			if (this.experts || !this.showUser) {
				valid = this.formObjectData.form.valid;
			}
			if (this.showUser && !this.experts) {
				valid = true;
			}
			if (valid) {
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				const skills = [];
				if (apiData && apiData.skills) {
					for (const skill of apiData.skills) {
						let skillLevel = skill.skillLevel;
						if (!skillLevel && this.actualSKills && this.actualSKills.length) {
							const findData = this.actualSKills.find(items => items.key === skill.key);
							if (findData) {
								skillLevel = findData.expectedSkillLevel;
							}
						}
						if (this.skills.fieldType === 'autoComplete') {
							if (skill.hasOwnProperty('key')) {
								if (skill.isAdd && !skill.isDelete) {
									skills.push(
										{
											skill: skill.key
										}
									);
								}
							} else if (skill.value) {
								if (skill.value.isAdd && !skill.value.isDelete) {
									skills.push(
										{
											skillName: skill.value.value
										}
									);
								}
							}
						} else {
							skills.push({
								skillLevel,
								skill: skill.key
							});
						}
					}
				}
				apiData.skills = skills;
				const visibility: any = {};
				if (apiData.channel) {
					const channelsID = [];
					for (const channel of apiData.channel) {
						if (channel.isAdd && !channel.isDelete) {
							channelsID.push(channel.key);
						}
					}
					if (channelsID.length > 0) {
						visibility.channel = channelsID;
					}
				}
				delete apiData.channel;
				if (Object.keys(visibility).length > 0) {
					apiData.settings = {
						visibility
					};
				}
				const resourceTypeStatus = this.baseService.resourceType;
				for (const status of resourceTypeStatus) {
					if (status.key === 'answer') {
						apiData.resourceTypeID = status.value;
					}
				}
				if (this.action === 'addQuestion') {
					apiData.authors = [
						{
							id: this.currentUser.userID
						}
					];
				}
				let wordsLength = apiData.title.split(' ').length;
				if (apiData.description) {
					let span = document.createElement('span');
					span.innerHTML = apiData.description;
					wordsLength = wordsLength + span.innerText.split(' ').length;
				} else {
					apiData.description = null;
				}
				apiData.resource = {
					duration: this.gfService.getEstimatedReadingTime(wordsLength, 'hh:mm')
				};
				if (this.showUser) {
					const experts = [];
					if (apiData.experts) {
						for (const user of apiData.experts) {
							if (user.isAdd && !user.isDelete) {
								experts.push(user.key);
							}
						}
						if (this.usersData && this.usersData.length) {
							for (const expert of this.usersData) {
								if (!experts.includes(expert.key) && expert.isAdd && !expert.isDelete) {
									experts.push(expert.key);
								}
							}
						}
					}
					apiData.experts = experts;
					this.submitQuestion(apiData);
				} else {
					this.title.isReadonly = true;
					this.description.isReadonly = true;
					this.skills.isReadonly = true;
					this.formObjectData.form.controls.title.disable({ emitEvent: false });
					this.formObjectData.form.controls.description.disable({ emitEvent: false });
					this.formObjectData.form.controls.skills.disable({ emitEvent: false });
					if (this.experts) {
						this.experts.isReadonly = false;
						this.formObjectData.form.controls.experts.enable({ emitEvent: false });
					}
					this.showUser = true;
					this.submitDisable = false;
				}
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	submitQuestion(apiData) {
		if (this.helpTriggered) {
			this.loader = true;
		} else {
			this.popupRef.componentInstance.popupLoader = true;
		}
		apiData.languageCode = 'en';
		let method;
		let message = 'question_posted';
		if (this.action === 'addQuestion') {
			method = this.apiService.addQuestion(apiData);
		} else if (this.action === 'editQuestion') {
			method = this.apiService.updateQuestion(apiData, this.resourceDetail.resourceID);
			message = 'question_updated';
		}
		// setTimeout(() => {
		// 	this.submitDisable = false;
		// 	if (this.helpTriggered) {
		// 		this.loader = false;
		// 	} else {
		// 		this.popupRef.componentInstance.popupLoader = false;
		// 	}
		// 	return;
		// }, 1000);
		// return;
		method
			.subscribe(
				(response) => {
					if (response) {
						if (this.action === 'addQuestion') {
							const userActivityData = {
								resourceID: (response && response.recordID) ? response.recordID.resourceID : null,
								authors: [
									{
										userID: this.currentUser.userID
									}
								]
							};
							this.baseService.logUserActivity('postquestion', 'learning', [''], { resourceData: userActivityData });
						}
						this.popupRef.close(this.gfService.JSONMerge(apiData, response.recordID));
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate(message),
							icon: 'check_circle_outline',
							position: 'before'
						});
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						alert: {
							id: 'add-alert'
						},
						form: this.formObjectData.form
					});
				}
			)
			.add(() => {
				this.submitDisable = false;
				if (this.helpTriggered) {
					this.loader = false;
				} else {
					this.popupRef.componentInstance.popupLoader = false;
				}
			});
	}

	formObjectReader(record) {
		this.formObject = record;
		const form: UntypedFormGroup = record.form;
		let subscribe;
		const skills = record.fields.find((items) => items.fieldColumn === 'skills');
		if (form.controls.skills && skills.fieldType === 'autoComplete') {
			form.controls.skills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (skills.selectedValue.length) {
								skills.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										skills.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										skills.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									skills.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								skills.options = [];
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		const usersField = this.experts;
		let userSubscribe;
		if (form.controls.experts && this.experts) {
			form.controls.experts.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (userSubscribe && !userSubscribe['closed']) {
						userSubscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							// const userFilter: any = { $and: [] };
							// const splitVal = controlResp.toLowerCase().split(' ');
							// for (const value of splitVal) {
							//   userFilter.$and.push({
							//     $or: {
							//       '$accountDetail.firstName$': { $substring: value },
							//       '$accountDetail.lastName$': { $substring: value }
							//     }
							//   });
							// }
							const apiData: any = {
								searchString: controlResp
							};
							if (this.formObjectData && this.formObjectData.fields && this.formObjectData.form) {
								let selectedSkills = [];
								const skillField = this.formObjectData.fields.find(items => items.fieldColumn === 'skills');
								if (skillField) {
									if (skillField.fieldType === 'autoComplete') {
										skillField.selectedValue.map(resp => {
											if (resp.hasOwnProperty('key')) {
												if (resp.isAdd && !resp.isDelete) {
													selectedSkills.push({
														skill: resp.key
													});
												}
											}
										});
									} else {
										if (this.formObjectData.form.controls.skills && this.formObjectData.form.controls.skills.value && this.formObjectData.form.controls.skills.value.length) {
											selectedSkills = this.formObjectData.form.controls.skills.value.map(skill => {
												return {
													skill: skill.key,
													skillLevel: skill.skillLevel
												};
											});
										}
									}
									if (selectedSkills && selectedSkills.length) {
										apiData.skills = encodeURIComponent(JSON.stringify(selectedSkills));
									}
								}
							}
							const header: any = {};
							let selectedValue = [];
							if (usersField.selectedValue.length) {
								usersField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							userSubscribe = this.profileApiService.userSearch(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										usersField.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										usersField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									usersField.options = [];
								}
							);
						} else {
							usersField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (record.form && record.form.controls.channel) {
			let subscribe;
			const channelField = record.fields.find((items) => items.fieldColumn === 'channel');
			record.form.controls.channel.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (channelField.selectedValue.length) {
								channelField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.channelsApiService.getChannelList(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.channelID)) {
													return items;
												}
											});
										}
										channelField.options = response.records.map((data) => {
											return {
												key: data.channelID,
												value: data.channelName
											};
										});
									} else {
										channelField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									channelField.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								channelField.options = [];
							} else {
								this.loadChannel(channelField);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

}
